import api from "../../Http/global-vars";
import { LocationFormData } from "../../repositories/user/LocationFormData";
import { FETCH_TIMELINE_ADMIN, FETCH_TIMELINE_FRONT } from "../types";

export const fetchtimelines = () => {
  return async (
    dispatch: (arg0: { type: string; payload: LocationFormData }) => void
  ) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("userToken")}`,
      },
    };
    const token = window.localStorage.getItem("userToken");

    const url = api + "timeline/";

    if (token) {
      await fetch(url, config)
        .then(async (res) => {
          const data = await res.json();
          dispatch({
            type: FETCH_TIMELINE_ADMIN,
            payload: data.results,
          });
        })
        .catch((error) => console.log("error", error?.response));
    }
  };
};

export const fetchtimelineFront = () => {
  return async (
    dispatch: (arg0: { type: string; payload: LocationFormData }) => void
  ) => {
    const url = api + "timelinebyvisitor/";

    await fetch(url)
      .then(async (res) => {
        const data = await res.json();
        dispatch({
          type: FETCH_TIMELINE_FRONT,
          payload: data.results,
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
